import React from "react";
import useSites from "../../hooks/useSites";
import Timeline from "./Timeline";

type Props = {
  customerId: string;
  resourceId: string;
  basePath: string;
};

const ResourceTimeline: React.FC<Props> = ({ customerId, resourceId, basePath }) => {
  const { data: sites } = useSites(basePath, customerId);

  if (!sites) return <></>;

  return (
    <>
      <div className="row">
        <div className="col-12">
          <div className="card card-dark">
            <div className="card-body p-0">
              <Timeline basePath={basePath} customerId={customerId} resourceId={resourceId} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ResourceTimeline;
